var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm.profile &&
      _vm.profile.banner &&
      _vm.showBanner &&
      _vm.profile.role.name == "guest"
        ? _c("div", { staticClass: "tf__init--popup" }, [
            _c("div", { staticClass: "tf__in-pu--box" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-close",
                  on: { click: _vm.onCloseBannerClicked },
                },
                [_c("i", { staticClass: "fas fa-times" })]
              ),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.profile.banner && _vm.profile.banner.banner_text
                    ) +
                    "\n      "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("notifications"),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("ProjectNavBar", {
            on: {
              calendarClicked: function ($event) {
                return _vm.handleCalendarClicked()
              },
              userClicked: function ($event) {
                return _vm.handleUserClicked()
              },
              headerLoginClicked: _vm.onHeaderLoginClicked,
              detailClicked: function ($event) {
                return _vm.handleDetailClicked()
              },
            },
          }),
          _vm.profile
            ? _c("router-view", {
                attrs: {
                  taskCreateFlag: _vm.taskCreateFlag,
                  taskLoadingFlag: _vm.taskLoadingFlag,
                },
                on: {
                  assignedByUserClicked: _vm.handleAssignedByUserClicked,
                  assignedToUserClicked: _vm.handleAssignedToUserClicked,
                  financeClicked: _vm._onFinanceClicked,
                  taskDblClick: _vm.handleTaskDblClick,
                  loginClicked: _vm.handleLoginClick,
                },
              })
            : _vm._e(),
          _c(
            "SidebarRight",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside",
                },
              ],
              class: [
                "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
                {
                  open: _vm.showSideBar,
                  "offcanvas-collapse--80p offcanvas-collapse--chat":
                    _vm.fullWidth,
                },
              ],
              on: { overlayClicked: _vm.outside },
            },
            [
              _c(_vm.currentView, {
                tag: "component",
                attrs: { editId: _vm.editId, data: _vm.data },
                on: {
                  closeClick: _vm.outside,
                  iAmNewClicked: _vm.handleIAmNewClicked,
                  backClickedFromRegister: function ($event) {
                    _vm.currentView = "Login"
                  },
                  backClickedFromForgot: function ($event) {
                    _vm.currentView = "Login"
                  },
                  forgotPasswordLinkClicked: function ($event) {
                    _vm.currentView = "Forgot"
                  },
                  registerSuccess: _vm.onRegisterSuccess,
                  resetPasswordSuccess: _vm.onResetPasswordSuccess,
                  userVerified: _vm.onUserVerificationSuccess,
                  taskCreated: _vm.onTaskCreated,
                  taskDeleted: _vm.outside,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }